import { Component, computed, inject, input, output } from "@angular/core";

import { Language } from "../../../../../../../constants/enums";
import { LanguageService } from "../../../../../../../services";

@Component({
  selector: "adaa-aikpi-period-toggle",
  template: `
    <button
      type="button"
      class="btn btn-link p-0 fw-bold text-reset text-decoration-none d-inline-flex align-items-center gap-1"
      [attr.dir]="isArabic() ? 'rtl' : 'ltr'"
      [attr.aria-expanded]="expanded()"
      (click)="toggled.emit()"
    >
      <i class="adaa-icon-expand_more" [style.transform]="iconRotation()"></i>
      {{ label() }}
    </button>
  `,
})
export class AikpiPeriodToggleComponent {
  private _languageService = inject(LanguageService);

  label = input<string | number>();
  expanded = input<boolean>(true);
  toggled = output<void>();

  isArabic = computed(() => this._languageService.current() === Language.Arabic);

  iconRotation = computed(() => {
    if (this.expanded()) return null;

    return this.isArabic() ? "rotate(90deg)" : "rotate(-90deg)";
  });
}
